import styled from "styled-components";

export const Button = styled.button`
  background: none;
  border: none;
  font-family: inherit;
  font-size: 1.3rem;
  margin: 0;
  padding: 0;
  text-align: left;
  width: 15rem;
  &:hover {
    cursor: pointer;
  }
`;

interface IAdminButton {
  isActive?: any;
}
export const AdminButton = styled(Button)<IAdminButton>`
  ${({ isActive, theme }) => `
    color: ${isActive ? theme.colors.blackTextTitle : theme.colors.gray72};
    font-weight: ${isActive ? 600 : 500};
  `}
`;

interface IUserButton {
  isActive?: any;
}
export const UserButton = styled(Button)<IUserButton>`
  ${({ isActive, theme }) => `
    color: ${isActive ? theme.colors.blackTextTitle : theme.colors.gray};
    font-weight: ${isActive ? 600 : 500};
  `}
`;

export const UnorderedList = styled.ul`
  list-style-type: none;
  margin: 2.3rem 0 0 0;
  max-height: 45rem;
  padding: 0;
  transition: max-height 0.2s ease-in;
`;
interface IItem {
  active?: any;
}
export const Item = styled.li<IItem>`
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-size: 1.3rem;
  font-weight: 700;

  .hide {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
  }
`;

export const SubItem = styled.li`
  margin-bottom: 1.6rem;
  margin-left: 2.4rem;
`;

export const GroupItem = styled.a`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
`;

export const Container = styled.div`
  margin-left: 1.7rem;
  margin-bottom: 2rem;
`;
